<template>
  <div
    @click="$emit('click', $event)"
    class="tag"
    :class="{ '--is-selected': isSelected }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tag',
  props: {
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
/**
 * Tag
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Tag, that can be used either as a filter item or as a label
 * @since 2021-11-01
**/

$component: 'tag';

.#{$component} {
  display: inline-block;
  @include padding-top(map-get($spacers, 3) / 4);
  @include padding-right(map-get($spacers, 5) / 3);
  @include padding-bottom(map-get($spacers, 3) / 4);
  @include padding-left(map-get($spacers, 5) / 3);
  border: 1px solid $sky-dark;
  border-radius: 50px;
  background-color: transparent;
  box-shadow: 0 1px 0 0 rgba(darken($primary, 10%), 0.1),
    inset 0 1px 0 1px rgba($white, 0.06);
  text-align: center;
  color: $ink-lighter;
  @include font-size($font-size-sm);
  line-height: $line-height-base-sm;
  font-weight: $font-weight-normal;
  cursor: pointer;

  @include hover() {
    box-shadow: 0px 0px 6px rgba($primary, 0.3);
  }

  &.--is-selected {
    border-color: $primary;
    color: $ink-light;
    font-weight: $font-weight-bold;
    background-color: $sky-lighter;
    box-shadow: 0px 0px 6px rgba($primary, 0.3);
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
